import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Inversion } from "../../models/trust/empleado/Inversion";
import { InversionService } from "../../service/trust/empleado/InversionService";

export const InstitucionInversion = ({ toast, id, catalogos, permss, soloLectura }) => {

    const omodel = new Inversion();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [esOtraInversion, setEsOtraInversion] = useState(false);
    const menuRef = useRef(null);

    const inversionSrv = new InversionService();
    const tablaInversion = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { inText, inDrop, inCalendar, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaInversion.lazyParams, id]);

    const loadLazyData = () => {
        tablaInversion.setLoading(true);
        const _params = { ...tablaInversion.lazyParams, idp: id };
        inversionSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaInversion.setTotalRecords(res.data.total);
            tablaInversion.setData(res.data.registros);
        }).finally(() => tablaInversion.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setEsOtraInversion(false);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.otro = catalogos?.otra_inversion;
        data.fecha_inversion = generic.dateToString(data.fecha_inversion);

        const request = getValues('id') == null
            ? inversionSrv.nuevo(data)
            : inversionSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        inversionSrv.consultar(idReg).then(res => {
            const _data = res.data.inversion;
            setEsOtraInversion(_data.tipo_inversion?.cat_id === catalogos?.otra_inversion?.cat_id);
            _data.fecha_inversion = generic.stringToDate(_data.fecha_inversion);
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const onChangeTipoInversion = (e) => {
        setEsOtraInversion(e.value?.cat_id === catalogos?.otra_inversion?.cat_id);
        setValue('otra_inversion', '');
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este registro de inversión?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                inversionSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_inversion" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Inversiones
            </span>
        </div>
    );

    return (
        <div className="componente-institucion-inversion">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_inversion" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaInversion} datos={tablaInversion.data} totalRegistros={tablaInversion.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nueva Inversión" : "Editar Inversión"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '620px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-chart-line text-primary"></i>
                                    INVERSIÓN
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inText('institucion', { icon: 'pi pi-building' }, 12)}
                        {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel }, esOtraInversion ? 4 : 6)}
                        {inDrop('tipo_inversion', catalogos?.tipo_inversion, { lab: omodel.optionLabel, chn: onChangeTipoInversion }, esOtraInversion ? 4 : 6)}
                        {esOtraInversion && inText('otra_inversion', { icon: 'pi pi-pencil' }, 4)}
                        {inCalendar('fecha_inversion', {}, 6)}
                        {inNumber('monto', 2, false, { prefix: '$ ' }, 6)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
